import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Layout } from "antd";
import Login from "./pages/Login";
import LoginRedirect from "./pages/LoginRedirect";
import { handleSignout } from "./util/functions";
import SignUp from "./pages/SignUp";
import SignUpConfirm from "./pages/SignUpConfirm";
import Modal from "./components/modal/RestrictedRoute";
import axios from "axios";
import TopBar from "./components/TopBar";
import Dashboard from "./pages/dashboard/Dashboard";
import Loading from "./components/loading/Loading"
import { primaryRole } from "./redux/slices/userSlice";
import TimeoutWarning from "./components/timeoutWarning/TimeOutWarning";

const { Header, Content, Footer } = Layout;

const url = (path) => {
  // enforce url path pattern with leading slash
  if (path[0] === "/") return path;
  return `/${path}`;
};

const App = () => {
  const primary_role = useSelector((state) => state.user.primaryRole);
  const signedIn = useSelector((state) => state.user.signedIn);
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const [redirecting, setRedirecting] = useState(false);



  // const checkPrimaryRole = async () => {
  //   if (signedIn && primaryRole !== "auditor") {
  //     let res = await axios.get("/auditor/business/account/whoAmi");
  //     dispatch(primaryRole(res.data.primary_role));
  //     setLoading(false)
  //   }

  // };

  useEffect(() => {
    const checkPrimaryRole = async () => {
      setLoading(true)
      if (signedIn === false) {
        setLoading(false)
      }
      if (signedIn) {

        if (window.location.pathname === "/comp/") {
          setRedirecting(true);
        }
        let res = await axios.get("/auditor/business/account/whoAmi");
        dispatch(primaryRole(res.data.primary_role));
        setLoading(false)

      }
    }
    checkPrimaryRole();
  }, [signedIn, primaryRole])



  const basename = useSelector((state) => state.routing.basename);



  const restrictedPageMessage = () => {
    return (
      <div>
        <Modal onReturnToSignup={() => handleSignout()} onReturn={() => handleReturn()} title="Restricted Page">
          <div style={{ fontSize: "16px" }}>
            The page you are trying to access is only accessible to
            Auditor users. Please sign up
            as an Auditor to gain access.

          </div>
        </Modal>
      </div>
    );
  };
  const handleReturn = () => {
    window.history.go(-1)
  }
  if (redirecting) {
    return <Loading />;
  }
  if (signedIn === false) {
    // setLoading(false)
    return (
      <BrowserRouter basename={"/auditor"}>
        <Routes>
          {/* Unauthorized user routes */}

          {/* Blank path is used in health check */}
          <Route
            exact
            path={""}
            element={<Login />}
          />
          <Route
            exact
            path={url("/login")}
            element={<Login />}
          />
          {/* used when webapp-frontend handles auditor sign in */}
          <Route
            exact
            path={url("/login/redirect")}
            element={<LoginRedirect />}
          />
          <Route
            exact
            path={url("/signup")}
            element={<SignUp />}
          />
          <Route
            exact
            path={url("/confirm_signup/:token")}
            element={<SignUpConfirm />}
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    )
  } else {
    if (loading === true) {
      return <Loading />
    }
    if (primary_role !== "auditor") {
      return (
        <div>
          {restrictedPageMessage()}
        </div>
      )

    } else {
      return (
        <BrowserRouter basename={"/auditor"}>
          <Layout style={{ minHeight: "100vh" }}>
            <Header>
              <TopBar />
            </Header>
            <TimeoutWarning />
            <Content>

              <Routes>
                {/* Authorized user routes */}
                <Route exact path={url("/dashboard")} element={<Dashboard />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Content>
            <Footer style={{ textAlign: "center" }}>
              Copyright © {new Date().getFullYear()} CISOBot
            </Footer>
          </Layout>
        </BrowserRouter>
      );
    }

  }
}

export default App;
